"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsTimezoneValid = exports.IsOpeningHoursValid = void 0;
const class_validator_1 = require("class-validator");
const moment = require("moment-timezone");
const time_1 = require("../../../../helpers/time");
const isValidOperationalDay = (day) => day >= 0 && day <= 6;
const isValidOperationalTime = (time) => time.length === 4 && (0, time_1.matchesMilitaryTime)(time);
function IsOpeningHoursValid() {
    return function (object, propertyName) {
        (0, class_validator_1.registerDecorator)({
            name: "IsOpeningHoursValid",
            target: object.constructor,
            propertyName: propertyName,
            validator: {
                validate(value, args) {
                    var _a;
                    const operationalPeriod = ((_a = value.openingHours) === null || _a === void 0 ? void 0 : _a.periods) || value;
                    if (!operationalPeriod || !Array.isArray(operationalPeriod)) {
                        return false;
                    }
                    return operationalPeriod.every((op) => {
                        if (!("open" in op) && !("close" in op)) {
                            return false;
                        }
                        return (isValidOperationalDay(op.open.day) &&
                            isValidOperationalTime(op.open.time) &&
                            isValidOperationalDay(op.close.day) &&
                            isValidOperationalTime(op.close.time));
                    });
                }
            }
        });
    };
}
exports.IsOpeningHoursValid = IsOpeningHoursValid;
function IsTimezoneValid() {
    return function (object, propertyName) {
        (0, class_validator_1.registerDecorator)({
            name: "timezoneValid",
            target: object.constructor,
            propertyName: propertyName,
            validator: {
                validate(value, args) {
                    return !!value.timeZoneId && !!moment.tz.zone(value.timeZoneId);
                }
            }
        });
    };
}
exports.IsTimezoneValid = IsTimezoneValid;
//# sourceMappingURL=locations.js.map